import { render, staticRenderFns } from "./BtnIconDetails.vue?vue&type=template&id=bcbba1ec&scoped=true&"
import script from "./BtnIconDetails.vue?vue&type=script&lang=js&"
export * from "./BtnIconDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcbba1ec",
  null
  
)

export default component.exports